import React from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux'

//Actions
import {authLogin} from 'actions/auth'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Lock from "@material-ui/icons/Lock";
// import LockOutline from "@material-ui/icons/LockOutline";

import {Redirect } from "react-router-dom";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import {
  success,
  danger,
} from 'actions/notification'
//Styles
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// @material-ui/icons
import logo from "assets/img/scope_markets_logo_small.png";
import imgUserLogin from "assets/img/User_Login_Icon.svg";

import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import "assets/scss/custom/react-chrome-fix.css";

import { getDefaultRoute } from "constants/authorisation.js";

class LoginPage extends React.Component {
  state={
    form:{
      login:'',
      password:'',
    },
    cardAnimaton: "cardHidden",
    showPassword: false,
  }
  inputSet=(name,value)=>{
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:value
      }
    })
  }
  //Login method
  login=(e)=>{
    if(e.preventDefault)
      e.preventDefault();
    this.props.login(this.state.form.login,this.state.form.password)
      .then(e=>e.token?this.props.success('Success',3):this.props.warning('Wrong Details',5))
      .catch(e=>this.props.danger('Wrong Details',5))
      ;
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount(){
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  render() {
    const { classes,isFetching } = this.props;
    
    if(this.props.auth.token) {
      return <Redirect to={getDefaultRoute(this.props.auth.permissions)}/>
    }
    return (
      <div className={classes.container}>
        <GridContainer justify="center" alignItems="center">
          <GridItem xs={4} sm={4} md={4}><br/></GridItem>
        
          <GridItem>
            <div className={classes.logoTop}>
            <a href="/" className={classes.logoLink}>
              <img src={logo} alt="logo" className={classes.imgLogo} />
            </a>
            </div>
          </GridItem>
          <GridItem xs={4} sm={4} md={4}><br/></GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={isFetching?null:this.login} autoComplete="off">
              <Card login className={classes.cardContainer}>
                <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`}>
                  
                  <div className={classes.socialLine}>
                    {/*<Person style={{ fontSize: 50 }}  className={classes.inputAdornmentIcon} />*/}
                    <img style={{ width: 70 }} src={imgUserLogin} alt="logo" className={classes.imgLogo} />
                  </div>
                  <h3 className={classes.cardTitle}>IB PORTAL</h3>
                </CardHeader>
                <CardBody className={classes.cardBody}>
                  <CustomInput
                    disabld={isFetching}
                    inputRootCustomClasses={classes.inputField}
                    id="username"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value:this.state.form.login,
                      onChange:(e)=>this.inputSet('login',e.target.value),
                      disabled:isFetching,
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>
                            <Person />
                          </Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  
                  <CustomInput
                  inputRootCustomClasses={classes.inputField}
                  labelText=""
                  id="password"
                  autocomplete="new-password"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                      value:this.state.form.password,
                      onChange:(e)=>this.inputSet('password',e.target.value),
                      disabled:isFetching,
                      type:(this.state.showPassword ? 'text' : 'password'),
                      startAdornment: (
                        <InputAdornment position="start" className={classes.inputAdornment}>
                          <Icon>
                            <Lock />
                          </Icon>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.handleClickShowPassword}
                              >
                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}

                />
                </CardBody>

                <CardFooter className={`${classes.justifyContentCenter} ${classes.cardFooter}`}>

                    {!isFetching
                      ?<GridItem xs={12} sm={12} md={12}>
                      <Button type="submit" color="info" size="lg" className={`${classes.justifyContentCenter} ${classes.btnSubmit}`} block onClick={isFetching?null:this.login}>
                        Log in
                      </Button>
                      <div style={{width:"100%"}}><br/></div>
                      <div style={{float:"left"}}>
                      
                       <FormControlLabel
                        control={
                          <Checkbox
                          color="default"
                          />
                        }
                        classes={{
                          label: classes.linkFooter
                        }}
                        label="Remember me"
                      />

                      </div>
                      {/*<div style={{float:"right",padding:"13px 0px"}}><a href="#"  className={classes.linkFooter}>Forgot password?</a></div>*/}
                      <div style={{width:"100%"}}><br/></div>
                      </GridItem>
                      :<div style={{width:"100%"}}><CustomLinearProgress color='primary'/></div>
                    }
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired
};
const state=(state)=>({
  auth:state.auth,
  isFetching:state.auth.isFetching,
})

const dispatch=(dispatch)=>({
  login:(login,password)=>dispatch(authLogin(login,password)),
  success:(text,time)=>dispatch(success(text,time)),
  danger:(text,time)=>dispatch(danger(text,time)),
});


export default withStyles(loginPageStyle)(connect(state,dispatch)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx